import { z } from 'zod';
const mwAccountGroup = z.object({
  id: z.string(),
  accountGroup: z.string(),
  mwEntity: z.string(),
});

export const getGroupsByCategorySchema = z.array(
  z.object({
    id: z.string(),
    isActive: z.boolean(),
    isFromManager: z.boolean().optional(),
    mwAccountGroupId: z.string().optional(),
    name: z.string(),
    maxLevel: z.number(),
    rootCode: z.string(),
    isSystem: z.boolean(),
    mwAccountGroup,
  })
);

export type GetGroupsByCategoryResponse = z.infer<typeof getGroupsByCategorySchema>;
